import { Pager } from "@smerth/gatsby-theme-theme-ui";
import pagerData from "../../../../documentation/data/pager.yaml";
import * as React from 'react';
export default {
  Pager,
  pagerData,
  React
};